$(function(){
  $('body').on('click', '.x-pagination-container a', function(){
      $('.x-underline-comments').append('<div class="comments-block--loading"></div>');
    }
  );

  $('.x-pick-accounter-button').on('click', function(){
      var link = $(this).data('url');
      $.ajax({
        type : 'GET',
        url : link,
        dataType: 'script'
      })
    }
  );

  $('body').on("click", '.x-table-reload' ,function () {
      if (boxFilters.is(':visible')) {
        buttonOpenFilters.trigger('click');
      }
      $('.accountants-boxes').append('<div class="loading-box"></div>');
    }
  );

  $('body').on("click", '.x-profiles-pagination-container a' ,function (e) {
      e.preventDefault();
      $.ajax({
        url: this.href,
        dataType: 'script',
        beforeSend: function() {
          $('.accountants-boxes').append('<div class="loading-box"></div>');
        }
      }).done(function() {
        $('html, body').stop(true, false).animate({
          scrollTop: $('.x-accountants-banner').height() + 100
        }, 500);
      });
      return false
    }
  );

  $('body').on("click",".x-form-button",function(e){
    e.preventDefault();

    $('.x-filters-open').trigger('click');
    $('.accountants-boxes').append('<div class="loading-box"></div>');

    $(".x-form").submit();
  });

  $('body').on("change", '.x-select-href' ,function () {
    $('.accountants-boxes').append('<div class="loading-box"></div>');

    var link = $(this).children("option:selected").data("href");

    $.ajax({
      type : 'GET',
      url : link,
      dataType: 'script'
    })
  });

  var loadCommentsAtStartup = function(field) {
    var link = $('.x-comments-loading-trigger').data('url');
    if(link !== undefined ) {
      $.ajax({
        type : 'GET',
        url : link,
        dataType: 'script'
      })
    }
  };

  var loadModalCustomAction = function(field) {
    var modalCustomAction = $('.x-bg-modal-window2').data('window-custom-action');

    if(modalCustomAction === 'opened_contact') {
      $('.x-open-modal-window2').trigger('click');
    }
  };

  $(document).ready(function(){
    loadCommentsAtStartup();
    loadModalCustomAction();
  })
});

$(document).on('submit', '#orderingForm', function (e) {
  e.preventDefault();

  $('#orderingForm button').addClass('disabled');
  $('#orderingForm').find('input').each(function () { $(this).attr('disabled', true) });

  const leadType = $(this).find('#lead_type').val();
  const accountantUUID = $(this).find('#accountant_uuid').val();

  $.ajax({
    url: $(this).attr('action'),
    type: 'POST',
    data: {
      user: {
        name: $(this).find('#name').val(),
        surname: $(this).find('#surname').val(),
        phone: $(this).find('#phone').val(),
        email: $(this).find('#email').val(),
        password: $(this).find('#password').val(),
        terms_of_service: $(this).find('#terms_of_service').val(),
        agree_marketing: $(this).find('#agree_marketing').val()
      }
    },
    success: function (response) {
      paramString = accountantUUID ? ('?accountant_uuid=' + accountantUUID + '&lead_type=' + leadType) : ('?lead_type=' + leadType)
      window.location.href = response.url + paramString;
    },
    error: function (response) {
      toastr.error(response.responseJSON.errors.join('<br>'))

      $('#orderingForm button').removeClass('disabled');
      $('#orderingForm').find('input').each(function () { $(this).attr('disabled', false) });
    }
  });
});
